import React, { useCallback, useState, useRef, useEffect } from "react";
import "./warranty.scss";
import { CrossIcon, DeleteIcon, EditIcon, SaveIcon } from "./SVGComponent";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackCard from "./BackCard";
import FrontCard from "./FrontCard";
import Field from "./Field";
import { _Api } from "../../../components/api/_call";
import {
  CONFIRM_DIALOG_TYPES,
  ConfirmDialog,
} from "components/common/modules/ConfirmDialog";
import { useTranslation } from "react-i18next";

const PRESETS = [
  { id: "red", color: "#A40A0D" },
  { id: "teal", color: "#52CBC4" },
  { id: "slate", color: "#36425E" },
];

const DEFAULT_FORM = {
  designation: "",
  title1: "",
  title2: "",
  subtitle: "",
  backTitle: "",
  footer1: "",
  footer2: "",
  footerSub: "",
};

const Warranty = () => {
   const { t } = useTranslation();
  const orgLogoLocal = localStorage.getItem("logo");
  const [form, setForm] = useState(DEFAULT_FORM);
  const [errors, setErrors] = useState({});
  const [activeColor, setActiveColor] = useState("red");
  const [selectedColors, setSelectedColors] = useState([
    {
      id: "red",
      color: "#A40A0D",
    },
  ]);
  const [customColor, setCustomColor] = useState("#A40A0D");
  const [logoSrc, setLogoSrc] = useState(orgLogoLocal);
  const [isSaving, setIsSaving] = useState(false);
  const [savedLogoUrl, setSavedLogoUrl] = useState(orgLogoLocal);
  const [mode, setMode] = useState("create");
  const [dialogStatus, setDialogStatus] = useState({
    delete: false,
    save: false,
    edit: false,
    cross: false,
  });

  const logoInputRef = useRef();
  const navigate = useNavigate();

  const set = useCallback(
    (key) => (val) => {
      setForm((f) => ({ ...f, [key]: val }));
      setErrors((e) => ({ ...e, [key]: undefined }));
    },
    [],
  );
  // const currentColor =
  //   activeColor === "custom"
  //     ? customColor
  //     : (PRESETS.find((p) => p.id === activeColor)?.color ?? "#A40A0D");

  const customEntry = selectedColors.find((c) => c.id === "custom");

  const currentColor =
    activeColor === "custom"
      ? (customEntry?.color ?? customColor)
      : (PRESETS.find((p) => p.id === activeColor)?.color ?? "#A40A0D");

  const getWarrantyData = async () => {
    try {
      const res = await _Api({}, `api/v1/APP/warranty/get`);
      if (res.code === 200) {
        const orgLogo = res?.orgLogo;
        if (orgLogo) {
          localStorage.setItem("logo", orgLogo);
          setLogoSrc(orgLogo);
          setSavedLogoUrl(orgLogo);
        }

        const d = res?.data;

        if (!d) {
          setMode("create");
          return;
        }

        setForm({
          designation: d.designation ?? DEFAULT_FORM.designation,
          title1: d.title1 ?? DEFAULT_FORM.title1,
          title2: d.title2 ?? DEFAULT_FORM.title2,
          subtitle: d.subtitle ?? DEFAULT_FORM.subtitle,
          backTitle: d.backTitle ?? DEFAULT_FORM.backTitle,
          footer1: d.footer1 ?? DEFAULT_FORM.footer1,
          footer2: d.footer2 ?? DEFAULT_FORM.footer2,
          footerSub: d.footerSub ?? DEFAULT_FORM.footerSub,
        });
        //   if (d.pick_color) {
        //   const matchedPreset = PRESETS.find(
        //     (p) => p.color.toLowerCase() === d.pick_color.toLowerCase(),
        //   );

        //   if (matchedPreset) {
        //     setActiveColor(matchedPreset.id);

        //  const savedColors =
        //   Array.isArray(d.colors)
        //     ? d.colors
        //         .map((item) => {
        //           if (typeof item === "string") {
        //             const preset = PRESETS.find(
        //               (p) => p.color.toLowerCase() === item.toLowerCase()
        //             );

        //             return preset
        //               ? { id: preset.id, color: preset.color }
        //               : { id: "custom", color: item };
        //           }

        //           return item;
        //         })
        //         .filter(Boolean)
        //     : [];

        //    setSelectedColors(
        //   savedColors.filter(
        //     (item, index, arr) =>
        //       arr.findIndex((c) => c.id === item.id) === index
        //   )
        // );
        //   } else {
        //     setCustomColor(d.pick_color);
        //     setActiveColor("custom");

        //     setSelectedColors([
        //       {
        //         id: "custom",
        //         color: d.pick_color,
        //       },
        //     ]);
        //   }
        // } else {
        //   setActiveColor("red");

        //   setSelectedColors([
        //     {
        //       id: "red",
        //       color: "#A40A0D",
        //     },
        //   ]);
        // }
        // if (d.pick_color) {
        //   const matchedPreset = PRESETS.find(
        //     (p) => p.color.toLowerCase() === d.pick_color.toLowerCase(),
        //   );
        //   if (matchedPreset) {
        //     setActiveColor(matchedPreset.id);
        //   } else {
        //     setCustomColor(d.pick_color);
        //     setActiveColor("custom");
        //   }
        // } else {
        //   setActiveColor("red");
        // }

        // if (d.logo) {
        //   setLogoSrc(d.logo);
        //   setSavedLogoUrl(d.logo);
        // }
        if (d.pick_color) {
          const savedColors = Array.isArray(d.colors)
            ? d.colors
                .map((item) => {
                  if (typeof item === "string") {
                    const preset = PRESETS.find(
                      (p) => p.color.toLowerCase() === item.toLowerCase(),
                    );
                    return preset
                      ? { id: preset.id, color: preset.color }
                      : { id: "custom", color: item };
                  }
                  return item;
                })
                .filter(Boolean)
            : [];

          const dedupedColors = savedColors.filter(
            (item, index, arr) =>
              arr.findIndex((c) => c.id === item.id) === index,
          );

          setSelectedColors(
            dedupedColors.length > 0
              ? dedupedColors
              : [{ id: "custom", color: d.pick_color }],
          );

          // Find which entry matches pick_color and activate THAT one
          const matched = dedupedColors.find(
            (c) => c.color.toLowerCase() === d.pick_color.toLowerCase(),
          );

          if (matched) {
            setActiveColor(matched.id);
            if (matched.id === "custom") {
              setCustomColor(matched.color);
            }
          } else {
            // pick_color doesn't match any saved swatch — treat it as custom
            setCustomColor(d.pick_color);
            setActiveColor("custom");
            setSelectedColors((prev) => {
              const withoutCustom = prev.filter((c) => c.id !== "custom");
              return [...withoutCustom, { id: "custom", color: d.pick_color }];
            });
          }
        } else {
          setActiveColor("red");
          setSelectedColors([{ id: "red", color: "#A40A0D" }]);
        }
        setMode("saved");
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getWarrantyData();
  }, []);

  const handleSave = async () => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      const res = await _Api(
        {
          ...form,
          pick_color: currentColor,
          colors: selectedColors,
          //  logo: logoSrc ?? res.orgLogo
        },
        `api/v1/APP/warranty/create`,
      );
      if (res.code === 200) {
        toast.success(t(res.message || "Warranty card created successfully!"));
        setMode("saved");
      } else {
        setErrors(t(res?.errors));
        toast.error(t(res.errors || "Failed to create warranty card."));
      }
    } catch (err) {
      toast.error(t(err.message || "Something went wrong"));
    } finally {
      setIsSaving(false);
    }
  };

  const handleUpdate = async () => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      const res = await _Api(
        {
          ...form,
          pick_color: currentColor,
          colors: selectedColors,
          // logo: logoChanged ? logoSrc : savedLogoUrl,
        },
        `api/v1/APP/warranty/update`,
      );
      if (res.code === 200) {
        toast.success(t(res.message || "Warranty card updated successfully!"));
        setMode("saved");
        // setLogoChanged(false);
        // setSavedLogoUrl(logoSrc ?? savedLogoUrl);
      } else {
        toast.error(t(res.errors || "Failed to update warranty card."));
      }
    } catch (err) {
      toast.error(t(err.message || "Something went wrong"));
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async () => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      const res = await _Api({}, `api/v1/APP/warranty/delete`);
      if (res.code === 200) {
        toast.success(t(res.message || "Warranty card deleted successfully!"));

        setForm(DEFAULT_FORM);
        setActiveColor("red");
        setSelectedColors([
          {
            id: "red",
            color: "#A40A0D",
          },
        ]);
        setCustomColor("#A40A0D");
        setLogoSrc(orgLogoLocal);
        setSavedLogoUrl(orgLogoLocal);
        setMode("create");
      } else {
        toast.error(t(res.errors || "Failed to delete warranty card."));
      }
    } catch (err) {
      toast.error(t(err.message || "Something went wrong"));
    } finally {
      setIsSaving(false);
    }
  };

  const isDisabled = mode === "saved";
  const showSaveCross = mode === "create";
  const showEditDel = mode === "saved" || mode === "editing";

  const blockTitle = (text, margin) => (
    <div
      style={{
        fontSize: 14,
        fontWeight: 400,
        color: "#606060",
        margin,
        // paddingBottom: 7,
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? "none" : "auto",
        transition: "opacity 0.3s ease",
      }}
    >
     {t(text)}
    </div>
  );

  return (
    <div className="main-warranty-container">
      <div className="left-side">
        <span className="main-head">{t(`Add Warranty Card`)}</span>

        <div className="customize-panel">
          <span className="text1">{t('Customize Panel')}</span>
          <div
            className={
              mode === "editing"
                ? "inventory-btn inventory-active-btn"
                : "inv-btn-disable"
            }
            onClick={() => {
              if (mode === "editing") {
                navigate("/app/admin/setup/warranty/inventory");
              }
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 4L10 16M16 10L4 10"
                stroke="#8A8A8A"
                strokeLinecap="round"
              />
            </svg>
            <span>{t('Inventory')}</span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "flex-start",
            padding: 20,
            paddingTop: 0,
          }}
        >
          <div style={{ flex: 1 }}>
            {blockTitle("Designation", "0px 0 15px")}
            <Field
              label="Designation"
              required
              id="designation"
              value={form.designation}
              onChange={set("designation")}
              isDisabled={isDisabled}
              error={errors?.designation?.[0]}
            />

            <hr />

            {blockTitle("Front", "15px 0")}
            <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div style={{ width: "75%" }}>
                <Field
                  label={t("Front Title Line 1")}
                  required
                  id="title1"
                  value={form.title1}
                  onChange={set("title1")}
                  isDisabled={isDisabled}
                  error={errors?.title1?.[0]}
                />
                <Field
                  label={t("Front Title Line 2")}
                  required
                  id="title2"
                  value={form.title2}
                  onChange={set("title2")}
                  isDisabled={isDisabled}
                  error={errors?.title2?.[0]}
                />
                <Field
                  label={t("Front Subtitle")}
                  required
                  id="subtitle"
                  value={form.subtitle}
                  onChange={set("subtitle")}
                  isDisabled={isDisabled}
                  error={errors?.subtitle?.[0]}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 5,
                  width: "25%",
                  opacity: isDisabled ? 0.5 : 1,
                }}
              >
                <div
                  className="logo-drop"
                  onClick={() => logoInputRef.current?.click()}
                  style={{
                    width: "100%",
                    cursor: isDisabled ? "default" : "pointer",
                  }}
                >
                  {logoSrc ? (
                    <img
                      src={logoSrc}
                      alt="logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <img
                      src={orgLogoLocal}
                      alt="logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
                <span style={{ fontSize: 11, color: "#6b6b6b" }}>{t('Upload')}</span>
              </div>
            </div>
            <hr />

            {blockTitle("Back", "15px 0")}
            <Field
              label={t("Back Card Title")}
              required
              id="backTitle"
              value={form.backTitle}
              onChange={set("backTitle")}
              isDisabled={isDisabled}
              error={errors?.backTitle?.[0]}
            />
            <Field
              label={t("Footer Title Line 1")}
              required
              id="footer1"
              value={form.footer1}
              onChange={set("footer1")}
              isDisabled={isDisabled}
              error={errors?.footer1?.[0]}
            />
            <Field
              label={t("Footer Title Line 2")}
              required
              id="footer2"
              value={form.footer2}
              onChange={set("footer2")}
              isDisabled={isDisabled}
              error={errors?.footer2?.[0]}
            />
            <Field
              label={t("Footer Subtitle")}
              id="footerSub"
              value={form.footerSub}
              onChange={set("footerSub")}
              isDisabled={isDisabled}
              error={errors?.footerSub?.[0]}
            />
            <hr />

            {/* Colors */}
            <div
              style={{
                marginTop: 20,
                opacity: isDisabled ? 0.5 : 1,
                pointerEvents: isDisabled ? "none" : "auto",
                transition: "opacity 0.3s ease",
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#6b6b6b",
                  marginBottom: 10,
                }}
              >
               {t(' Color. Pick your favorite.')}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "flex-end",
                  flexWrap: "wrap",
                }}
              >
                {PRESETS.map((p) => {
                  const isSelected = selectedColors.some((c) => c.id === p.id);
                  const isActive = activeColor === p.id;
                  return (
                    <div
                      key={p.id}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 4,
                        width: 36,
                      }}
                    >
                      <div
                        key={p.id}
                        style={{ position: "relative", display: "inline-flex" }}
                      >
                        <div
                          className={`swatch${activeColor === p.id ? " active" : ""}`}
                          style={{
                            background: p.color,
                            opacity: isSelected ? 1 : 0.5,
                            transition: "opacity 0.2s",
                          }}
                          // onClick={() => {
                          //   setActiveColor(p.id);
                          //   setSelectedColors((prev) =>
                          //     prev.includes(p.id) ? prev : [...prev, p.id],
                          //   );
                          // }}
                          onClick={() => {
                            setActiveColor(p.id);

                            setSelectedColors((prev) => {
                              const exists = prev.some((c) => c.id === p.id);

                              if (exists) return prev;

                              return [...prev, { id: p.id, color: p.color }];
                            });
                          }}
                          title={p.id}
                        />
                        {isSelected && (
                          <div
                            style={{
                              position: "absolute",
                              top: -4,
                              right: -4,
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              background: "#fff",
                              border: "1px solid #ccc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedColors((prev) =>
                                prev.filter((c) => c.id !== p.id),
                              );
                            }}
                          >
                            <svg
                              width="7"
                              height="7"
                              viewBox="0 0 8 8"
                              fill="none"
                            >
                              <line
                                x1="1.5"
                                y1="1.5"
                                x2="6.5"
                                y2="6.5"
                                stroke="#666"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                              />
                              <line
                                x1="6.5"
                                y1="1.5"
                                x2="1.5"
                                y2="6.5"
                                stroke="#666"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          marginTop: 6,
                          height: 16,
                          fontSize: 12,
                          color: "#000000",
                        }}
                      >
                        {isActive ? "Default" : ""}
                      </div>
                    </div>
                  );
                })}

                {/* Custom color picker */}
                {/* <div
                  className={`swatch-add${activeColor === "custom" ? " active" : ""}`}
                  style={
                    activeColor === "custom"
                      ? {
                          borderColor: "#fff",
                          boxShadow: "0 0 0 2.5px #333",
                          transform: "scale(1.1)",
                        }
                      : {}
                  }
                  title="Pick custom color"
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 14 14"
                    fill="none"
                    stroke="#999"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                  >
                    <line x1="7" y1="1" x2="7" y2="13" />
                    <line x1="1" y1="7" x2="13" y2="7" />
                  </svg>
                  <input
                    type="color"
                    value={customColor}
                    onChange={(e) => {
                      setCustomColor(e.target.value);
                      setActiveColor("custom");
                    }}
                  />
                </div> */}
                {/* Custom color picker */}
                {/* <div style={{ position: "relative", display: "inline-flex" }}>
              <div
  className={`swatch-add${activeColor === "custom" ? " active" : ""}`}
  style={{
    background: customEntry ? (customEntry.color ?? customColor) : undefined,
    opacity: customEntry ? 1 : 0.5,
    ...(activeColor === "custom"
      ? { borderColor: "#fff", boxShadow: "0 0 0 2.5px #333", transform: "scale(1.1)" }
      : {}),
  }}
  title="Pick custom color"
>
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 14 14"
                      fill="none"
                      stroke="#999"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                    >
                      <line x1="7" y1="1" x2="7" y2="13" />
                      <line x1="1" y1="7" x2="13" y2="7" />
                    </svg>
                    <input
                      type="color"
                      value={customColor}
                      onChange={(e) => {
                        const newColor = e.target.value;
                        setCustomColor(newColor);
                        setActiveColor("custom");

                        setSelectedColors((prev) => {
                          const withoutCustom = prev.filter(
                            (c) => c.id !== "custom",
                          );
                          return [
                            ...withoutCustom,
                            { id: "custom", color: newColor },
                          ];
                        });
                      }}
                    />
                  </div>
                 

                  {selectedColors.some((c) => c.id === "custom") && (
                    <div
                      style={{
                        position: "absolute",
                        top: -4,
                        right: -4,
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        background: "#fff",
                        border: "1px solid #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedColors((prev) =>
                          prev.filter((c) => c.id !== "custom"),
                        );
                        if (activeColor === "custom") {
                          setActiveColor("red");
                        }
                      }}
                    >
                      <svg width="7" height="7" viewBox="0 0 8 8" fill="none">
                        <line
                          x1="1.5"
                          y1="1.5"
                          x2="6.5"
                          y2="6.5"
                          stroke="#666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <line
                          x1="6.5"
                          y1="1.5"
                          x2="1.5"
                          y2="6.5"
                          stroke="#666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                  )}
                </div> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-flex",
                    }}
                  >
                    <div
                      className={`swatch-add${activeColor === "custom" ? " active" : ""}`}
                      style={{
                        background: customEntry
                          ? (customEntry.color ?? customColor)
                          : undefined,
                        opacity: customEntry ? 1 : 0.5,

                        ...(activeColor === "custom"
                          ? {
                              borderColor: "#fff",
                              boxShadow: "0 0 0 2.5px #333",
                              transform: "scale(0.96)",
                            }
                          : {}),
                      }}
                      title="Pick custom color"
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 14 14"
                        fill="none"
                        stroke="#999"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                      >
                        <line x1="7" y1="1" x2="7" y2="13" />
                        <line x1="1" y1="7" x2="13" y2="7" />
                      </svg>

                      <input
                        type="color"
                        value={customColor}
                        onChange={(e) => {
                          const newColor = e.target.value;

                          setCustomColor(newColor);
                          setActiveColor("custom");

                          setSelectedColors((prev) => {
                            const withoutCustom = prev.filter(
                              (c) => c.id !== "custom",
                            );

                            return [
                              ...withoutCustom,
                              {
                                id: "custom",
                                color: newColor,
                              },
                            ];
                          });
                        }}
                      />
                    </div>

                    {selectedColors.some((c) => c.id === "custom") && (
                      <div
                        style={{
                          position: "absolute",
                          top: -4,
                          right: -4,
                          width: 14,
                          height: 14,
                          borderRadius: "50%",
                          background: "#fff",
                          border: "1px solid #ccc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();

                          setSelectedColors((prev) =>
                            prev.filter((c) => c.id !== "custom"),
                          );

                          if (activeColor === "custom") {
                            setActiveColor("red");
                          }
                        }}
                      >
                        <svg width="7" height="7" viewBox="0 0 8 8" fill="none">
                          <line
                            x1="1.5"
                            y1="1.5"
                            x2="6.5"
                            y2="6.5"
                            stroke="#666"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                          <line
                            x1="6.5"
                            y1="1.5"
                            x2="1.5"
                            y2="6.5"
                            stroke="#666"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      marginTop: 10,
                      height: 16,
                      fontSize: 12,
                      color: "#000000",
                      textAlign: "center",
                    }}
                  >
                    {activeColor === "custom" ? "Default" : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="right-side"
        style={{
          transition: "opacity 0.3s ease",
        }}
      >
        <div className="customize-panel" style={{ height: "34px" }}>
          <span className="text1">{t('Card Preview')}</span>

          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {showSaveCross && (
              <>
                <div
                  // onClick={handleSave}
                  onClick={() => setDialogStatus((p) => ({ ...p, save: true }))}
                  style={{
                    cursor: isSaving ? "not-allowed" : "pointer",
                    opacity: isSaving ? 0.5 : 1,
                  }}
                  title="Save"
                >
                  <SaveIcon />
                </div>

                <div
                  // onClick={() => navigate("/app/admin/dashboard")}
                  onClick={() =>
                    setDialogStatus((p) => ({ ...p, cross: true }))
                  }
                  style={{
                    cursor: "pointer",
                  }}
                  title="Close"
                >
                  <CrossIcon />
                </div>
                {Object.values(form).some((v) => v !== "") ? (
                  <div
                    // onClick={handleDelete}
                    onClick={() => {
                      setForm(DEFAULT_FORM);
                      setActiveColor("red");
                      setCustomColor("#A40A0D");
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                    title="trash"
                  >
                    <DeleteIcon />
                  </div>
                ) : null}
              </>
            )}

            {showEditDel && (
              <>
                <div
                  onClick={() => {
                    if (mode === "saved") {
                      setMode("editing");
                      // setDialogStatus((p) => ({ ...p, edit: true }));
                    } else {
                      handleUpdate();
                    }
                  }}
                  style={{
                    cursor: isSaving ? "not-allowed" : "pointer",
                    opacity: isSaving ? 0.5 : 1,
                  }}
                  title={mode === "editing" ? "Save Changes" : "Edit"}
                >
                  {mode === "editing" ? <SaveIcon /> : <EditIcon />}
                </div>
                {mode === "editing" ? (
                  <div
                    // onClick={() => navigate("/app/admin/dashboard")}
                    onClick={() =>
                      // setDialogStatus((p) => ({ ...p, cross: true }))

                      setMode("saved")
                    }
                    style={{
                      cursor: "pointer",
                    }}
                    title="Close"
                  >
                    <CrossIcon />
                  </div>
                ) : (
                  <div
                    // onClick={handleDelete}
                    onClick={() =>
                      setDialogStatus((p) => ({ ...p, delete: true }))
                    }
                    style={{
                      cursor: isSaving ? "not-allowed" : "pointer",
                      opacity: isSaving ? 0.5 : 1,
                    }}
                    title="Delete"
                  >
                    <DeleteIcon />
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            columnGap: "60px",
            rowGap: "30px",
            padding: "22% 0%",
          }}
        >
          <div className="card-preview-wrap">
            <FrontCard
              data={{
                title1: form.title1,
                title2: form.title2,
                subtitle: form.subtitle,
              }}
              color={currentColor}
              logoSrc={logoSrc}
            />
          </div>
          <div className="card-preview-wrap">
            <BackCard
              data={{
                backTitle: form.backTitle,
                footer1: form.footer1,
                footer2: form.footer2,
                footerSub: form.footerSub,
              }}
              color={currentColor}
            />
          </div>
        </div>
      </div>
      <ConfirmDialog
        show={dialogStatus.cross}
        type={CONFIRM_DIALOG_TYPES.DISCARD}
        onCancel={() => setDialogStatus((p) => ({ ...p, cross: false }))}
        onConfirm={() => {
          setDialogStatus((p) => ({ ...p, cross: false }));
          // navigate("/app/admin/dashboard");
          setForm(DEFAULT_FORM);
          setActiveColor("red");
          setCustomColor("#A40A0D");
          setSelectedColors([
            {
              id: "red",
              color: "#A40A0D",
            },
          ]);
        }}
      />

      <ConfirmDialog
        show={dialogStatus.delete}
        type={CONFIRM_DIALOG_TYPES.DELETE}
        confirmDisabled={isSaving}
        onCancel={() => setDialogStatus((p) => ({ ...p, delete: false }))}
        onConfirm={() => {
          setDialogStatus((p) => ({ ...p, delete: false }));
          handleDelete();
        }}
      />

      <ConfirmDialog
        show={dialogStatus.save}
        type={CONFIRM_DIALOG_TYPES.SAVE}
        onCancel={() => setDialogStatus((p) => ({ ...p, save: false }))}
        onConfirm={() => {
          setDialogStatus((p) => ({ ...p, save: false }));
          handleSave();
        }}
      />
    </div>
  );
};

export default Warranty;
